import { render } from "./LifeCycle.vue?vue&type=template&id=60c390c0&scoped=true"
import script from "./LifeCycle.vue?vue&type=script&lang=ts"
export * from "./LifeCycle.vue?vue&type=script&lang=ts"

import "./LifeCycle.vue?vue&type=style&index=0&id=60c390c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60c390c0"

export default script